import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './utils/filterhandle'
import 'default-passive-events'
import md5 from 'js-md5' // 加密密码
import AES from "@/utils/AES.js";
Vue.prototype.$AES = AES 
Vue.prototype.$md5 = md5 

// import jquery from 'jquery'
import './utils/rem.js'
// lib-flexible 会把根字号固定成 54px，导致桌面端 0.72 缩放、高分屏溢出穿模，改用 rem.js
// import 'lib-flexible'
// Vue.prototype.$ = jquery 
let sUserAgent = navigator.userAgent.toLowerCase();
  let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  let bIsMidp = sUserAgent.match(/midp/i) == "midp";
  let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  let bIsAndroid = sUserAgent.match(/android/i) == "android";
  let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  // if (
  //   bIsIpad ||
  //   bIsIphoneOs ||
  //   bIsMidp ||
  //   bIsUc7 ||
  //   bIsUc ||
  //   bIsAndroid ||
  //   bIsCE ||
  //   bIsWM
  // ) {
  //   // window.location.href = "http://m.shenyangcubeassociation.org.cn/";
  //   // window.location.href = "http://m.chessassociation.net/";
  //   window.location.href = "http://www.cubeassociation.net/jumpropeweb/mobile/";
  // } else {
  //   //  啥也不干
  //   // window.location.href = "http://www.chessassociation.net/"
  // }

ElementUI.Dialog.props.lockScroll.default = false; // 解决vue+element ui 弹窗出现,滚动条消失,页面抖动
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
